const middleware = {}

middleware['affiliate'] = require('../middleware/affiliate.js')
middleware['affiliate'] = middleware['affiliate'].default || middleware['affiliate']

middleware['has-permission'] = require('../middleware/has-permission.js')
middleware['has-permission'] = middleware['has-permission'].default || middleware['has-permission']

middleware['i18n'] = require('../middleware/i18n.js')
middleware['i18n'] = middleware['i18n'].default || middleware['i18n']

middleware['permission'] = require('../middleware/permission.js')
middleware['permission'] = middleware['permission'].default || middleware['permission']

export default middleware
